import { render, staticRenderFns } from "./ccvideoflow.vue?vue&type=template&id=374d740d&lang=pug&"
import script from "./ccvideoflow.vue?vue&type=script&lang=js&"
export * from "./ccvideoflow.vue?vue&type=script&lang=js&"
import style0 from "./ccvideoflow.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports